import { getUserInfo, loginApi, refreshTokenApi } from '@/api'
import { getToken, setToken, removeToken, getRefreshToken, setRefreshToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    refreshToken: getRefreshToken(),
    account: undefined,
    address: undefined,
    avatar: undefined,
    company: undefined,
    email: undefined,
    idCard: undefined,
    idFrontImg: undefined,
    mobile: undefined,
    name: undefined,
    realStatus: undefined,
    userAgree: undefined,
    hasLogin: false,
    loginDlog: false,
    agreeDlog: false
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_HASLOGIN: (state, hasLogin) => {
    state.hasLogin = hasLogin
  },
  SET_AGREEDLOG: (state, agreeDlog) => {
    state.agreeDlog = agreeDlog
  },
  SET_LOGINDIGO: (state, loginDlog) => {
    state.loginDlog = loginDlog
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_REFRESH_TOKEN: (state, refreshToken) => {
    state.refreshToken = refreshToken
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  // 校验是否同意了承诺书
  checkAgree ({ commit, state }) {
    if (state.groupId + '' === '1' && state.userAgree == '2') { // 未同意
      commit('SET_AGREEDLOG', true)
    } else if (state.userAgree == '1') { // 已同意
      commit('SET_AGREEDLOG', false)
    }
  },
  // user login
  login ({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      loginApi({ account: account.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.accessToken)
        commit('SET_REFRESH_TOKEN', data.refreshToken)
        commit('SET_HASLOGIN', true)
        commit('SET_LOGINDIGO', false)
        setToken(data.accessToken)
        setRefreshToken(data.refreshToken)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo(state.token).then(response => {
        const { data } = response
        if (!data) {
          commit('SET_HASLOGIN', false)
          commit('SET_LOGINDIGO', true)
          return reject('验证失败，请重新登录.')
        }
        const { account, address, avatar, company, email, idCard, idFrontImg, mobile, name, realStatus, groupId, userAgree } = data
        state.groupId = groupId
        state.account = account
        state.address = address
        state.avatar = avatar
        state.company = company
        state.email = email
        state.idCard = idCard
        state.idFrontImg = idFrontImg
        state.mobile = mobile
        state.name = name
        state.realStatus = realStatus
        state.userAgree = userAgree
        commit('SET_HASLOGIN', true)
        commit('SET_LOGINDIGO', false)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout ({ commit, state }) {
    removeToken() // must remove  token  first
    resetRouter()
    commit('SET_HASLOGIN', false)
    commit('RESET_STATE')
  },
  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },

  // refresh token
  refreshToken ({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 调用刷新token的API
      refreshTokenApi({ refreshToken: state.refreshToken })
        .then(response => {
          const { data } = response
          // 更新token
          commit('SET_TOKEN', data.accessToken)
          commit('SET_REFRESH_TOKEN', data.refreshToken)
          setToken(data.accessToken)
          setRefreshToken(data.refreshToken)

          // 执行等待队列中的请求
          if (window.tokenRefreshQueue) {
            window.tokenRefreshQueue.forEach(cb => cb())
            window.tokenRefreshQueue = []
          }

          resolve(data)
        })
        .catch(error => {
          // 刷新失败，清除token
          removeToken()
          commit('RESET_STATE')
          reject(error)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
